<!--
  Side view of the dunning type object. Same one-navigation-point-at-a-time shape as the full view,
  minus the node view: the canvas needs at least 600px to be operable and is therefore not offered
  in a side panel (see the component's class comment).

  The closing @else renders the overview, which makes it the fallback for `?navItem=nodeView` and
  for any other action this view does not know.
-->
@if (initialized && dto) {

    <div class="bd-dunning-type-side mt-3">

        @if (childTables[activeNavigationItem?.action]) {

            <bd-dunning-type-child-table
                    [dunningTypeId]="objectIdentifier.objectId"
                    [child]="childTables[activeNavigationItem.action]">
            </bd-dunning-type-child-table>

        } @else {

            <bd-dunning-type-overview
                    [dunningTypeId]="objectIdentifier.objectId"
                    [dunningTypeDto]="$any(dto)">
            </bd-dunning-type-overview>

        }

    </div>

}
